// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"36":"MarketTrendsPage.loadable","161":"PriceMyRentalResultsPage.loadable"}[chunkId] || chunkId) + "." + {"36":"ebb5616c","161":"cc19aca2","355":"f629e7c7","914":"8b0e96cf"}[chunkId] + ".js";
};